import React from 'react'
import PropTypes from 'prop-types'

const Logo = ({ isEmailOnly }) => {
  return (
    <div className='fullscreen-logo'>
      {isEmailOnly ? (
        <img alt='Apprentus' src='/assets/design1/header/non-index-logo@2x.png' width={192} height={34} />
      ) : (
        <a href='/'>
          <img alt='Apprentus' src='/assets/design1/header/non-index-logo@2x.png' width={192} height={34} />
        </a>
      )}
    </div>
  )
}

Logo.propTypes = {
  isEmailOnly: PropTypes.bool
}

export default Logo
